import { registerRoutings } from "rootRouting";
import store from "rootStore";
import { configType, permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";
import { menusUrl } from "../Menus/config";
import MenuListsTable from "./reducers/MenuListsTableReducer";
import MenuListsSaga from "./saga";

export const baseMenuListsUrl = "/lists";
export const menusListsUrl = `${menusUrl}/:menuId/lists`;
const permissionKey = "menus.lists";

const getConfig = (permissions: permissionsType) => {
    const modulePermissions = permissions.filter(
        (item) => item.indexOf(permissionKey) === 0
    );

    const config: configType = {
        permissions: {
            create: false,
            delete: false,
            update: false,
            read: false,
        },
        routing: [],
        url: menusListsUrl,
    };
    let routing: routingType = [];

    if (modulePermissions.indexOf(permissionKey + ".read") !== -1) {
        config.permissions.read = true;

        store.reducerManager?.add("MenuListsTable", MenuListsTable);
        store.injectSaga?.("MenuListsSaga", MenuListsSaga);

        routing.push({
            path: menusListsUrl,
            element: (
                <AsyncComponent path="MenuLists/pages/MenusListsIndexPage" />
            ),
        });
    }

    if (modulePermissions.indexOf(permissionKey + ".create") !== -1) {
        config.permissions.create = true;

        routing.push({
            path: `${menusListsUrl}/create`,
            element: (
                <AsyncComponent path="MenuLists/pages/MenusListsCreatePage" />
            ),
        });
    }

    if (modulePermissions.indexOf(permissionKey + ".update") !== -1) {
        config.permissions.update = true;

        routing.push({
            path: `${menusListsUrl}/:id/edit`,
            element: (
                <AsyncComponent path="MenuLists/pages/MenusListsEditPage" />
            ),
        });
    }

    if (modulePermissions.indexOf(permissionKey + ".delete") !== -1) {
        config.permissions.delete = true;
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerRoutings(routing);
    }

    return config;
};

export default getConfig;
